import React from 'react'
import PropTypes from 'prop-types'

const handleClick = (coursenum, linkType, ext, timeframe) => {
  const linkMap = {
    Topic: '',
    Section: 'detailed',
    Reading: 'reading',
    Video: 'video',
  }
  let link = `/instructor/progress.download/${coursenum}/${ext.substring(1)}/${
    linkMap[linkType]
  }/${timeframe}/`
  $.getScript(link)
}
const getLinkString = linkType => {
  const linkStrings = {
    Topic: 'Completion Data By Topic',
    Section: 'Completion Data By Section',
    Reading: 'Reading Log',
    Video: 'Video Log',
  }
  return linkStrings[linkType]
}

const DownloadLink = props => {
  return (
    <a
      onClick={() =>
        handleClick(props.coursenum, props.linkType, props.ext, props.timeframe)
      }
    >
      {props.ext === '.xlsx' ? (
        <div className="icon icon_file_excel" />
      ) : (
        <div className="icon icon_file8" />
      )}
      {getLinkString(props.linkType)} {`(${props.ext})`}
    </a>
  )
}

DownloadLink.propTypes = {
  linkType: PropTypes.string.isRequired,
  coursenum: PropTypes.string.isRequired,
  ext: PropTypes.string.isRequired,
  timeframe: PropTypes.string.isRequired,
}

export default DownloadLink
